import { Component, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { FormSchemaDetailedDto, FormTemplateClient } from '@unity/clients';
import { TypedDirective } from '@unity/directives/typed.directive';
import { ChipWorkflowStateSharedComponent } from '@unity/shared/presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';
import { SortConfig } from '@unity/utils/types';
import { GridSharedComponent } from '../composed/grid-shared/grid-shared.component';
import { LinkGridcellSharedComponent } from '../presentation/link-gridcell-shared/link-gridcell-shared.component';

@Component({
  selector: 'unity-grid-form-template-shared',
  imports: [KENDO_GRID, GridSharedComponent, LinkGridcellSharedComponent, TypedDirective, ChipWorkflowStateSharedComponent],
  templateUrl: './grid-form-template-shared.component.html',
  styleUrl: './grid-form-template-shared.component.scss',
})
export class GridFormTemplateSharedComponent extends AbstractGridComponent<FormSchemaDetailedDto> {
  private readonly formTemplateClient = inject(FormTemplateClient);

  /* Resources */
  protected override resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      return query ? { query } : undefined;
    },
    stream: ({ params: { query } }) => this.formTemplateClient.getAllAsDetailed(query.page, query.pageSize, query.orderBy, query.filter),
  });
  /* Data */
  protected defaultSort: SortConfig[] = [
    {
      field: 'created_dt',
      dir: 'desc',
    },
  ];

  protected defaultFilter: CompositeFilterDescriptor = {
    logic: 'and',
    filters: [
      {
        field: 'current_state.name',
        operator: 'neq',
        value: 'Archived',
      },
    ],
  };
}
